import styled from 'styled-components';

import { InputText } from 'ui/inputs';
import { pxToRem } from 'utils/convert';

type FieldTextInputProps = {
  className?: string;
  dataTest: string;
  error: boolean;
  onChange: (e: any, { type, value }: { type: string; value: string }) => void;
  placeholder?: string;
  readOnly?: boolean;
  value: string;
};

export const StyledInputText = styled(InputText)`
  flex: 2;
  margin-right: ${pxToRem(5)};
`;

export const FieldTextInput = ({
  className,
  dataTest,
  error,
  onChange,
  placeholder,
  readOnly,
  value = '',
}: FieldTextInputProps) => {
  const handleChange = (inputValue: string) => {
    onChange({}, { type: 'text', value: inputValue });
  };
  return (
    <StyledInputText
      className={className}
      hasError={error}
      onChange={handleChange}
      placeholder={placeholder}
      isReadOnly={readOnly}
      value={value}
      data-test={dataTest}
    />
  );
};
